<template>
  <div class="row mb-1">
    <div v-if="$slots['default']" class="my-2"><slot name="default"></slot></div>
    <slot name="columnOne"></slot>
    <slot name="columnTwo"></slot>
  </div>
</template>
